/** 客户端：系统 → 架构 → 多版本（与后端 ClientPlatformCatalog 对齐） */

/** 首页/登录页展示顺序：安卓 → iOS → Windows → 麒麟 → Mac */
export const CLIENT_DOWNLOAD_ORDER = [
  { key: "android", title: "安卓端", tabShort: "安卓", matchName: "APK下载", welcomeId: "2", fallbackIcon: "el-icon-mobile-phone" },
  { key: "ios", title: "iOS", tabShort: "iOS", matchName: "iOS", welcomeId: "12", fallbackIcon: "el-icon-mobile" },
  { key: "windows", title: "Windows端", tabShort: "Windows", matchName: "QT下载", welcomeId: "3", fallbackIcon: "el-icon-monitor" },
  { key: "kylin", title: "麒麟系统", tabShort: "麒麟", matchName: "QT(麒麟V10触摸屏)", welcomeId: "8", fallbackIcon: "el-icon-cpu" },
  { key: "mac", title: "macOS", tabShort: "Mac", matchName: "Mac", welcomeId: "11", fallbackIcon: "el-icon-apple" },
];

export const CLIENT_TYPES = [
  { key: "android", title: "安卓", managePath: "/clientManage/apk", packageType: "apk" },
  { key: "ios", title: "iOS", managePath: "/clientManage/ios", channel: "qt_ios" },
  { key: "windows", title: "Windows", managePath: "/clientManage/qt", channel: "qt_win" },
  { key: "kylin", title: "麒麟", managePath: "/clientManage/qt", channel: "qt_kylin" },
  { key: "mac", title: "macOS", managePath: "/clientManage/mac", channel: "qt_mac" },
];

/** 后台 QT 类客户端分栏：Windows+麒麟 / Mac / iOS */
export const QT_MANAGE_DESKTOP_CHANNELS = ["qt_win", "qt_kylin"];

export function qtManageScopeFromPath(path) {
  const p = String(path || "");
  if (p.indexOf("/clientManage/mac") >= 0) return "mac";
  if (p.indexOf("/clientManage/ios") >= 0) return "ios";
  return "desktop";
}

export function qtManageConfig(scope) {
  if (scope === "mac") {
    return {
      scope: "mac",
      versionApi: "mac",
      packageType: "mac",
      paramKey: "mac_version_pro",
      fixedChannel: "qt_mac",
      allowedChannels: ["qt_mac"],
      listPath: "/clientManage/mac",
      addPath: "/clientManage/mac/add",
      editPath: "/clientManage/mac/edit",
      uploadLabel: "上传 macOS 安装包",
      toolbarAdd: "上传 Mac",
      listLabels: { file: "Mac 安装包", version: "版本号" },
    };
  }
  if (scope === "ios") {
    return {
      scope: "ios",
      versionApi: "ios",
      packageType: "ios",
      paramKey: "ios_version_pro",
      fixedChannel: "qt_ios",
      allowedChannels: ["qt_ios"],
      listPath: "/clientManage/ios",
      addPath: "/clientManage/ios/add",
      editPath: "/clientManage/ios/edit",
      uploadLabel: "上传 iOS 安装包",
      toolbarAdd: "上传 iOS",
      listLabels: { file: "iOS 安装包", version: "版本号" },
    };
  }
  return {
    scope: "desktop",
    versionApi: "qt",
    packageType: "qt",
    paramKey: "qt_version_pro",
    fixedChannel: "",
    allowedChannels: QT_MANAGE_DESKTOP_CHANNELS,
    listPath: "/clientManage/qt",
    addPath: "/clientManage/qt/add",
    editPath: "/clientManage/qt/edit",
    uploadLabel: "上传 QT",
    toolbarAdd: "上传 QT",
    listLabels: { file: "QT 安装包", version: "QT 版本" },
  };
}

const CLIENT_WELCOME_IDS = new Set(CLIENT_DOWNLOAD_ORDER.map((c) => c.welcomeId));

export function isClientWelcomeEntry(item) {
  if (!item) return false;
  if (clientTypeFromWelcomeItem(item)) return true;
  const id = String(item.id || "");
  return CLIENT_WELCOME_IDS.has(id);
}

export function isAuxiliaryWelcomeEntry(item) {
  return item && !isClientWelcomeEntry(item);
}

/** 用户端 / 后台：仅麒麟、Mac 需要选架构 */
export function archOptionsForClientType(clientType) {
  if (clientType === "kylin") return ARCH_OPTIONS.qt_kylin;
  if (clientType === "mac") return ARCH_OPTIONS.qt_mac;
  return [];
}

/** 未上传任何安装包时的统一提示 */
export const CLIENT_EMPTY_PACKAGE_MSG = "暂无安装包，敬请期待";

export function releasesRoute(clientType, cpuArch, from) {
  const query = { tab: clientType };
  if (needsArchPicker(clientType) && cpuArch) {
    query.arch = cpuArch;
  }
  if (from) {
    query.from = from;
  }
  return { path: "/client/releases", query };
}

export const QT_CHANNELS = [
  { label: "Windows", value: "qt_win" },
  { label: "麒麟 V10", value: "qt_kylin" },
  { label: "macOS", value: "qt_mac" },
  { label: "iOS", value: "qt_ios" },
];

export const ARCH_OPTIONS = {
  android: [
    { label: "ARM64（主流）", value: "arm64" },
    { label: "ARM32", value: "armeabi-v7a" },
    { label: "x86_64", value: "x86_64" },
  ],
  qt_kylin: [
    { label: "x86", value: "x86" },
    { label: "ARM", value: "arm" },
  ],
  qt_mac: [
    { label: "Apple Silicon", value: "arm64" },
    { label: "Intel", value: "x86_64" },
  ],
  qt_ios: [
    { label: "真机", value: "arm64" },
    { label: "模拟器", value: "x86_64" },
  ],
};

export function archOptionsForChannel(channel) {
  if (!channel || channel === "qt_win" || channel === "qt_ios" || channel === "android") {
    return [];
  }
  if (channel === "qt_kylin") return ARCH_OPTIONS.qt_kylin;
  if (channel === "qt_mac") return ARCH_OPTIONS.qt_mac;
  return ARCH_OPTIONS[channel] || [];
}

/** 仅麒麟、Mac 在公开下载页需要用户选架构；安卓 / iOS 合并展示全部包 */
export function needsArchPicker(clientType) {
  return ["kylin", "mac"].includes(clientType);
}

export function defaultArch(clientType) {
  if (clientType === "kylin") return "x86";
  return "arm64";
}

export function channelLabel(channel) {
  const m = {
    qt_win: "Windows",
    qt_kylin: "麒麟",
    qt_mac: "macOS",
    qt_ios: "iOS",
    android: "安卓",
  };
  return m[channel] || channel;
}

export function uploadAccept(channel) {
  if (channel === "qt_win") return ".exe";
  if (channel === "qt_mac") return ".dmg,.pkg,.zip";
  if (channel === "qt_ios") return ".ipa";
  return "";
}

export function uploadTip(channel, tt) {
  const t = tt || ((s) => s);
  if (channel === "qt_win") return t("Windows 请上传 .exe");
  if (channel === "qt_mac") return t("Mac 请上传 .dmg / .pkg / .zip");
  if (channel === "qt_ios") return t("iOS 请上传 .ipa");
  if (channel === "qt_kylin") return t("麒麟版本可上传任意格式安装包（文件名需带后缀）");
  return t("请上传安装包");
}

export function clientTypeFromWelcomeItem(item) {
  const id = String(item.id || "");
  const name = item.name || "";
  if (id === "2" || name.indexOf("APK") >= 0) return "android";
  if (name.indexOf("Mac") >= 0 || name.indexOf("mac") >= 0) return "mac";
  if (name.indexOf("iOS") >= 0 || name.indexOf("IOS") >= 0) return "ios";
  if (id === "8" || name.indexOf("麒麟") >= 0) return "kylin";
  if (id === "3" || name.indexOf("QT") >= 0 || name.indexOf("Windows") >= 0) return "windows";
  return null;
}
